import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=60847577&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=60847577&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports